
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'YbSvgBook',
  props: {
    colors: {
      type: Array as PropType<string[]>,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '48'
    },
    height: {
      type: String,
      default: '48'
    }
  }
})
